import React, { useState, useRef, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { getIcon } from '../shared/utils/_icons.jsx';
import SaveIcon from '@mui/icons-material/Save';

export const RCMonitorDetails = ({ currentCrisisDetails, crisisId, handleSaveClick }) => {

    const [newCrisisDetails, setNewCrisisDetails] = useState({
        riskcrisiselement: currentCrisisDetails.riskcrisiselement,
        status: currentCrisisDetails.status,
        header: currentCrisisDetails.header,
        action: currentCrisisDetails.action,
        severityLevel: currentCrisisDetails.severityLevel,
        ongoingCrisis: currentCrisisDetails.ongoingCrisis,
    });

    const [isHeaderFocused, setIsHeaderFocused] = useState(false);
    const [isActionFocused, setIsActionFocused] = useState(false);

    const headerTextArea = useRef(null)
    const actionTextArea = useRef(null)

    const toggleHeaderFocus = () => {
        setIsHeaderFocused(prev => !prev)
    }

    const headerUnfocus = () => {
        if (isHeaderFocused) setIsHeaderFocused(false)
    }

    const headerFocus = () => {
        if (!isHeaderFocused) setIsHeaderFocused(true)
    }

    const handleHeaderChange = (event) => {
        const { value } = event.target
        setNewCrisisDetails({ ...newCrisisDetails, header: value })
    }

    const toggleActionFocus = () => {
        setIsActionFocused(prev => !prev)
    }

    const actionUnfocus = () => {
        if (isActionFocused) setIsActionFocused(false)
    }

    const actionFocus = () => {
        if (!isActionFocused) setIsActionFocused(true)
    }

    const handleActionChange = (event) => {
        const { value } = event.target
        setNewCrisisDetails({ ...newCrisisDetails, action: value })
    }


    useEffect(() => {
        if (isHeaderFocused) {
            headerTextArea.current.focus();
        } else {
            headerTextArea.current.blur();
        }
    }, [isHeaderFocused]);

    useEffect(() => {
        if (isActionFocused) {
            actionTextArea.current.focus();
        } else {
            actionTextArea.current.blur();
        }
    }, [isActionFocused]);

    return (
        <>
            {newCrisisDetails &&
                (<Paper elevation={2} sx={{ borderRadius: '10px', height: '100%', width: 'auto', padding: '1rem', margin: '0 1rem' }}>
                    <Typography sx={{ color: '#F19100' }} variant='h6'>
                        Input data
                    </Typography>
                    <Typography sx={{ color: 'gray' }} variant='caption'>
                        Modified on {new Date(currentCrisisDetails.lastModified).toLocaleDateString('en-US')}
                    </Typography>
                    <Divider sx={{ marginBottom: '2rem' }} />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.2rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Risk/Crisis Element
                        </Typography>
                        <Select
                            sx={{ width: '60%', color: 'rgba(0,0,0,0.6)' }}
                            value={newCrisisDetails.riskcrisiselement}
                            onChange={event => {
                                const { value } = event.target
                                setNewCrisisDetails({ ...newCrisisDetails, riskcrisiselement: value })
                            }}
                            variant='standard'
                        >

                            <MenuItem value={'Geo'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('LocationOnOutlined', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Geo</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Financial'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('AttachMoney', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Financial</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Sourcing Flexibility'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('Search', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Sourcing Flexibility</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Supplier OTIF'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('PersonOutline', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Supplier OTIF</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Planning'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('DescriptionOutlined', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Planning</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Energy'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('BatteryCharging90Icon', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Energy</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={"Quality Risk"}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('QualityIcon', true, { style: { color: 'gray', width: '25px', fontSize: '1.2rem', fontFamily: 'inherit' } })}
                                    <div>Quality</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Other'}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    {getIcon('Risk', true, { style: { color: 'gray', minWidth: '25px' } })}
                                    <div>Other</div>
                                </div>
                            </MenuItem>
                        </Select>
                    </div>
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.2rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Risk/Crisis Header
                        </Typography>
                        <textarea
                            ref={headerTextArea}
                            style={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: 'rgb(105,105,105)', border: '1px solid rgb(196,196,196)', borderRadius: '4px', fontSize: '12px', width: '60%', resize: 'none' }}
                            onFocus={headerFocus}
                            onBlur={headerUnfocus}
                            value={newCrisisDetails.header}
                            onChange={handleHeaderChange}
                            rows="5" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.2rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Ongoing Crisis?
                        </Typography>
                        <Select
                            label="ongoingCrisisSelect"
                            sx={{ width: '60%', color: 'rgba(0,0,0,0.6)' }}
                            value={newCrisisDetails.ongoingCrisis}
                            onChange={event => {
                                const { value } = event.target
                                setNewCrisisDetails({ ...newCrisisDetails, ongoingCrisis: value })
                            }}
                            variant='standard'
                        >
                            <MenuItem value={'Yes'}>
                                Yes
                            </MenuItem>
                            <MenuItem value={'No'}>
                                No
                            </MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.2rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Severity Level
                        </Typography>
                        <Select
                            label="severityLevelSelect"
                            sx={{ width: '60%', color: 'rgba(0,0,0,0.6)' }}
                            value={newCrisisDetails.severityLevel}
                            onChange={event => {
                                const { value } = event.target
                                setNewCrisisDetails({ ...newCrisisDetails, severityLevel: value })
                            }}
                            variant='standard'
                        >
                            <MenuItem value={'High'}>
                                High
                            </MenuItem>
                            <MenuItem value={'Medium'}>
                                Medium
                            </MenuItem>
                            <MenuItem value={'Low'}>
                                Low
                            </MenuItem>
                        </Select>
                    </div>
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.2rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Action
                        </Typography>
                        <textarea
                            ref={actionTextArea}
                            style={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: 'rgb(105,105,105)', border: '1px solid rgb(196,196,196)', borderRadius: '4px', fontSize: '12px', width: '60%', resize: 'none' }}
                            onFocus={actionFocus}
                            onBlur={actionUnfocus}
                            value={newCrisisDetails.action}
                            onChange={handleActionChange}
                            rows="5" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4rem' }}>
                        <Typography variant='body2' sx={{ fontWeight: '400', width: '6vw' }}>
                            Action Status
                        </Typography>
                        <Select
                            label="actionStatusSelect"
                            sx={{ width: '60%', color: 'rgba(0,0,0,0.6)' }}
                            value={newCrisisDetails.status}
                            onChange={event => {
                                const { value } = event.target
                                setNewCrisisDetails({ ...newCrisisDetails, status: value })
                            }}
                            variant='standard'
                        >
                            <MenuItem value={'Mitigation/BCP ready'}>
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className={'rc-risk-table-risk-bubble'}
                                        style={{ backgroundColor: '#64A80A', marginTop: '0.4rem' }}>
                                        {''}
                                    </div>
                                    <div>Mitigation/BCP Ready</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Mitigation/BCP identified'}>
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className={'rc-risk-table-risk-bubble'}
                                        style={{ backgroundColor: '#F19100', marginTop: '0.4rem' }}>
                                        {''}
                                    </div>
                                    <div>Mitigation/BCP Identified</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={'Mitigation/BCP Being identified'}>
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className={'rc-risk-table-risk-bubble'}
                                        style={{ backgroundColor: '#D00032', marginTop: '0.4rem' }}>
                                        {''}
                                    </div>
                                    <div>Mitigation/BCP Being identified</div>
                                </div>
                            </MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            sx={{ color: '#F19100' }}
                            variant='text'
                            onClick={() => handleSaveClick(crisisId, newCrisisDetails)}
                        >
                            <SaveIcon />
                            Save
                        </Button>
                    </div>
                </Paper >)}
        </>
    )
}